import React from 'react';
import { RefreshCw, X } from 'lucide-react';

interface PWAUpdatePromptProps {
  show: boolean;
  onUpdate: () => void;
  onDismiss: () => void;
}

/**
 * Non-intrusive banner shown when a new service worker is waiting.
 * Replaces the native `confirm()` dialog with branded UI.
 */
const PWAUpdatePrompt: React.FC<PWAUpdatePromptProps> = ({ show, onUpdate, onDismiss }) => {
  if (!show) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[60] w-[calc(100%-2rem)] max-w-md animate-slide-up">
      <div className="flex items-center gap-3 rounded-xl bg-primary-600 px-4 py-3 text-white shadow-lg">
        <RefreshCw className="h-5 w-5 shrink-0 animate-spin-slow" />
        <p className="flex-1 text-sm font-medium">
          A new version is available.
        </p>
        <button
          onClick={onUpdate}
          className="rounded-lg bg-white/20 px-3 py-1.5 text-xs font-semibold hover:bg-white/30 transition-colors"
        >
          Update
        </button>
        <button
          onClick={onDismiss}
          className="rounded-full p-1 hover:bg-white/20 transition-colors"
          aria-label="Dismiss"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default PWAUpdatePrompt;
